/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrPersonReduced
 */
export interface SolrPersonReduced  {
    /**
     * 
     * @type {string}
     * @memberof SolrPersonReduced
     */
    id?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrPersonReduced
     */
    name?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrPersonReduced
     */
    gnd?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrPersonReduced
     */
    orcid?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrPersonReduced
     */
    organisations?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrPersonReduced
     */
    projects?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof SolrPersonReduced
     */
    recordCreationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SolrPersonReduced
     */
    recordChangeDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SolrPersonReduced
     */
    editorialStatus?: string;
}

/**
 * Check if a given object implements the SolrPersonReduced interface.
 */
export function instanceOfSolrPersonReduced(value: object): value is SolrPersonReduced {
    return true;
}

export function SolrPersonReducedFromJSON(json: any): SolrPersonReduced {
    return SolrPersonReducedFromJSONTyped(json, false);
}

export function SolrPersonReducedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrPersonReduced {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
              'name': json['name'] == null ? undefined : json['name'],
              'gnd': json['gnd'] == null ? undefined : json['gnd'],
              'orcid': json['orcid'] == null ? undefined : json['orcid'],
              'organisations': json['organisations'] == null ? undefined : json['organisations'],
              'projects': json['projects'] == null ? undefined : json['projects'],
                'recordCreationDate': json['recordCreationDate'] == null ? undefined : (new Date(json['recordCreationDate'])),
                'recordChangeDate': json['recordChangeDate'] == null ? undefined : (new Date(json['recordChangeDate'])),
                  'editorialStatus': json['editorialStatus'] == null ? undefined : json['editorialStatus'],
    };
}

export function SolrPersonReducedToJSON(json: any): SolrPersonReduced {
    return SolrPersonReducedToJSONTyped(json, false);
}

export function SolrPersonReducedToJSONTyped(value?: SolrPersonReduced | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'] == null? value['name']: value['name'],
        'gnd': value['gnd'] == null? value['gnd']: value['gnd'],
        'orcid': value['orcid'] == null? value['orcid']: value['orcid'],
        'organisations': value['organisations'] == null? value['organisations']: value['organisations'],
        'projects': value['projects'] == null? value['projects']: value['projects'],
        'recordCreationDate': value['recordCreationDate']?.toISOString(),
        'recordChangeDate': value['recordChangeDate']?.toISOString(),
        'editorialStatus': value['editorialStatus'],
    };
}


